import keyMirror from 'keymirror'

export default keyMirror({
  GET_CARD_MARKET_PLACES_REQUEST: null,
  GET_CARD_MARKET_PLACES_SUCCESS: null,
  GET_CARD_MARKET_PLACES_FAILED: null,

  GET_CARD_MARKET_PLACE_DETAIL_REQUEST: null,
  GET_CARD_MARKET_PLACE_DETAIL_SUCCESS: null,
  GET_CARD_MARKET_PLACE_DETAIL_FAILED: null,

  DELETE_CARD_MARKET_PLACE_REQUEST: null,
  DELETE_CARD_MARKET_PLACE_SUCCESS: null,
  DELETE_CARD_MARKET_PLACE_FAILED: null,

  ADD_CARD_MARKET_PLACE_REQUEST: null,
  ADD_CARD_MARKET_PLACE_SUCCESS: null,
  ADD_CARD_MARKET_PLACE_FAILED: null,

  UPDATE_CARD_MARKET_PLACE_REQUEST: null,
  UPDATE_CARD_MARKET_PLACE_SUCCESS: null,
  UPDATE_CARD_MARKET_PLACE_FAILED: null,

  UPDATE_CARD_MARKET_PLACE_CONTENT_REQUEST: null,
  UPDATE_CARD_MARKET_PLACE_CONTENT_SUCCESS: null,
  UPDATE_CARD_MARKET_PLACE_CONTENT_FAILED: null,

  UPDATE_FILTER_CARD_MARKET_PLACE_SUCCESS: null,

  ADD_CARD_MARKET_PLACE_CONTENT_REQUEST: null,
  ADD_CARD_MARKET_PLACE_CONTENT_SUCCESS: null,
  ADD_CARD_MARKET_PLACE_CONTENT_FAILED: null,

  GET_CARD_MARKET_PLACE_CONTENTS_REQUEST: null,
  GET_CARD_MARKET_PLACE_CONTENTS_SUCCESS: null,
  GET_CARD_MARKET_PLACE_CONTENTS_FAILED: null,

  CHANGE_CARD_MARKET_PLACE_STATUS_REQUEST: null,
  CHANGE_CARD_MARKET_PLACE_STATUS_SUCCESS: null,
  CHANGE_CARD_MARKET_PLACE_STATUS_FAILED: null
})
